/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAbgrenzungenArbeitszeitsaldoDto } from '../models/work-abgrenzungen-arbeitszeitsaldo-dto';
import { WorkAbgrenzungenBezahltDto } from '../models/work-abgrenzungen-bezahlt-dto';
import { WorkAbgrenzungenErtragVerbauterProjekteDto } from '../models/work-abgrenzungen-ertrag-verbauter-projekte-dto';
import { WorkAbgrenzungenFerienguthabenDto } from '../models/work-abgrenzungen-ferienguthaben-dto';
import { WorkAbgrenzungenNachBauDto } from '../models/work-abgrenzungen-nach-bau-dto';
import { WorkAbgrenzungenNochNichtBezahltDto } from '../models/work-abgrenzungen-noch-nicht-bezahlt-dto';
import { WorkAbgrenzungenNochNichtFakturiertDto } from '../models/work-abgrenzungen-noch-nicht-fakturiert-dto';
import { WorkAbgrenzungenStundenabgrenzungNegativDto } from '../models/work-abgrenzungen-stundenabgrenzung-negativ-dto';
import { WorkAbgrenzungenStundenabgrenzungPositivDto } from '../models/work-abgrenzungen-stundenabgrenzung-positiv-dto';
import { WorkAbgrenzungenUngebautDto } from '../models/work-abgrenzungen-ungebaut-dto';
import { WorkAbgrenzungenVorausbezahltDto } from '../models/work-abgrenzungen-vorausbezahlt-dto';
import { WorkAbgrenzungenWarningsDto } from '../models/work-abgrenzungen-warnings-dto';
import { WorkAbsencesReportForBusinessDivisionDto } from '../models/work-absences-report-for-business-division-dto';
import { WorkAbsencesReportForUserDto } from '../models/work-absences-report-for-user-dto';
import { WorkBuildsByContainerIdYearAndMonthDto } from '../models/work-builds-by-container-id-year-and-month-dto';
import { WorkCalculationitem } from '../models/work-calculationitem';
import { WorkDebtor } from '../models/work-debtor';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkKrankheitUnfallTageDto } from '../models/work-krankheit-unfall-tage-dto';
import { WorkLeadConversionDto } from '../models/work-lead-conversion-dto';
import { WorkLeadsChartsDto } from '../models/work-leads-charts-dto';
import { WorkLohnlisteEntryDto } from '../models/work-lohnliste-entry-dto';
import { WorkNochNichtFakturierteLeistungenProjectDto } from '../models/work-noch-nicht-fakturierte-leistungen-project-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkPerformanceKundenberaterDto } from '../models/work-performance-kundenberater-dto';
import { WorkPerformanceMontageDto } from '../models/work-performance-montage-dto';
import { WorkReservationsChartsDto } from '../models/work-reservations-charts-dto';
import { WorkRevenueByYearAndMonthDto } from '../models/work-revenue-by-year-and-month-dto';
import { WorkRevenueForecastByContainerIdYearAndMonthDto } from '../models/work-revenue-forecast-by-container-id-year-and-month-dto';
import { WorkSalesByContainertypeDto } from '../models/work-sales-by-containertype-dto';
import { WorkSendEmailToAgentsDto } from '../models/work-send-email-to-agents-dto';
import { WorkSensDeklarationItemDto } from '../models/work-sens-deklaration-item-dto';
import { WorkSpesentageDto } from '../models/work-spesentage-dto';
import { WorkStatisticsAndFactsForAxovaKaDto } from '../models/work-statistics-and-facts-for-axova-ka-dto';
import { WorkTask } from '../models/work-task';
import { WorkTimerecordBalancesByYearMonthAndUserIdDto } from '../models/work-timerecord-balances-by-year-month-and-user-id-dto';
import { WorkTimerecorddetailsByDateDto } from '../models/work-timerecorddetails-by-date-dto';
import { WorkTimerecorddetailsGroupedByUserDto } from '../models/work-timerecorddetails-grouped-by-user-dto';
import { WorkTransformedBankFileDto } from '../models/work-transformed-bank-file-dto';
import { WorkUploadBankFileDto } from '../models/work-upload-bank-file-dto';
import { WorkUserV2 } from '../models/work-user-v-2';
import { WorkUseremployment } from '../models/work-useremployment';
import { WorkUseremploymentMutationTypesEnum } from '../models/work-useremployment-mutation-types-enum';
import { WorkUseremploymentTypeEnum } from '../models/work-useremployment-type-enum';
import { WorkUseremploymentWithChangesDto } from '../models/work-useremployment-with-changes-dto';
import { WorkWegspesenDto } from '../models/work-wegspesen-dto';

@Injectable({ providedIn: 'root' })
export class WorkReportsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetWarnings()` */
  static readonly ReportsAbgrenzungenV2ControllerGetWarningsPath = '/v2/reports/abgrenzungen/warnings';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetWarnings()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetWarnings$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenWarningsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetWarningsPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenWarningsDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetWarnings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetWarnings(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenWarningsDto> {
    return this.reportsAbgrenzungenV2ControllerGetWarnings$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenWarningsDto>): WorkAbgrenzungenWarningsDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte()` */
  static readonly ReportsAbgrenzungenV2ControllerGetErtragVerbauterProjektePath = '/v2/reports/abgrenzungen/ertrag-verbauter-projekte';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenErtragVerbauterProjekteDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetErtragVerbauterProjektePath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenErtragVerbauterProjekteDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenErtragVerbauterProjekteDto> {
    return this.reportsAbgrenzungenV2ControllerGetErtragVerbauterProjekte$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenErtragVerbauterProjekteDto>): WorkAbgrenzungenErtragVerbauterProjekteDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen()` */
  static readonly ReportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungenPath = '/v2/reports/abgrenzungen/noch-nicht-fakturiert';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenNochNichtFakturiertDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenNochNichtFakturiertDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenNochNichtFakturiertDto> {
    return this.reportsAbgrenzungenV2ControllerGetNochNichtFakturierteLeistungen$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenNochNichtFakturiertDto>): WorkAbgrenzungenNochNichtFakturiertDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen()` */
  static readonly ReportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungenPath = '/v2/reports/abgrenzungen/noch-nicht-bezahlt';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenNochNichtBezahltDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenNochNichtBezahltDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenNochNichtBezahltDto> {
    return this.reportsAbgrenzungenV2ControllerGetNochNichtBezahlteLeistungen$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenNochNichtBezahltDto>): WorkAbgrenzungenNochNichtBezahltDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetBezahlteLeistungen()` */
  static readonly ReportsAbgrenzungenV2ControllerGetBezahlteLeistungenPath = '/v2/reports/abgrenzungen/bezahlt';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetBezahlteLeistungen()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetBezahlteLeistungen$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenBezahltDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetBezahlteLeistungenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenBezahltDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetBezahlteLeistungen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetBezahlteLeistungen(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenBezahltDto> {
    return this.reportsAbgrenzungenV2ControllerGetBezahlteLeistungen$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenBezahltDto>): WorkAbgrenzungenBezahltDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen()` */
  static readonly ReportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungenPath = '/v2/reports/abgrenzungen/vorausbezahlt';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenVorausbezahltDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenVorausbezahltDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenVorausbezahltDto> {
    return this.reportsAbgrenzungenV2ControllerGetVorausbezahlteLeistungen$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenVorausbezahltDto>): WorkAbgrenzungenVorausbezahltDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten()` */
  static readonly ReportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjektenPath = '/v2/reports/abgrenzungen/kreditoren-ungebaut';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenUngebautDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjektenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenUngebautDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenUngebautDto> {
    return this.reportsAbgrenzungenV2ControllerGetKreditorenVonUngebautenProjekten$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenUngebautDto>): WorkAbgrenzungenUngebautDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetKreditorenNachBau()` */
  static readonly ReportsAbgrenzungenV2ControllerGetKreditorenNachBauPath = '/v2/reports/abgrenzungen/kreditoren-nach-bau';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetKreditorenNachBau()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetKreditorenNachBau$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenNachBauDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetKreditorenNachBauPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenNachBauDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetKreditorenNachBau$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetKreditorenNachBau(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenNachBauDto> {
    return this.reportsAbgrenzungenV2ControllerGetKreditorenNachBau$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenNachBauDto>): WorkAbgrenzungenNachBauDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv()` */
  static readonly ReportsAbgrenzungenV2ControllerGetStundenabgrenzungPositivPath = '/v2/reports/abgrenzungen/stundenabgrenzung-positiv';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungPositivDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetStundenabgrenzungPositivPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungPositivDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenStundenabgrenzungPositivDto> {
    return this.reportsAbgrenzungenV2ControllerGetStundenabgrenzungPositiv$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungPositivDto>): WorkAbgrenzungenStundenabgrenzungPositivDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ()` */
  static readonly ReportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativPath = '/v2/reports/abgrenzungen/stundenabgrenzung-negativ';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungNegativDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungNegativDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenStundenabgrenzungNegativDto> {
    return this.reportsAbgrenzungenV2ControllerGetStundenabgrenzungNegativ$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenStundenabgrenzungNegativDto>): WorkAbgrenzungenStundenabgrenzungNegativDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetFerienguthaben()` */
  static readonly ReportsAbgrenzungenV2ControllerGetFerienguthabenPath = '/v2/reports/abgrenzungen/ferienguthaben';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetFerienguthaben()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetFerienguthaben$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenFerienguthabenDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetFerienguthabenPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenFerienguthabenDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetFerienguthaben$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetFerienguthaben(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenFerienguthabenDto> {
    return this.reportsAbgrenzungenV2ControllerGetFerienguthaben$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenFerienguthabenDto>): WorkAbgrenzungenFerienguthabenDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo()` */
  static readonly ReportsAbgrenzungenV2ControllerGetArbeitszeitsaldoPath = '/v2/reports/abgrenzungen/arbeitszeitsaldo';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAbgrenzungenArbeitszeitsaldoDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerGetArbeitszeitsaldoPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAbgrenzungenArbeitszeitsaldoDto>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<WorkAbgrenzungenArbeitszeitsaldoDto> {
    return this.reportsAbgrenzungenV2ControllerGetArbeitszeitsaldo$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAbgrenzungenArbeitszeitsaldoDto>): WorkAbgrenzungenArbeitszeitsaldoDto => r.body)
    );
  }

  /** Path part for operation `reportsAbgrenzungenV2ControllerExportExcel()` */
  static readonly ReportsAbgrenzungenV2ControllerExportExcelPath = '/v2/reports/abgrenzungen/export-excel';

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbgrenzungenV2ControllerExportExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerExportExcel$Response(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbgrenzungenV2ControllerExportExcelPath, 'get');
    if (params) {
      rb.query('year', params.year, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: reports:abgrenzungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbgrenzungenV2ControllerExportExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbgrenzungenV2ControllerExportExcel(
    params: {
      year: number;
      month: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reportsAbgrenzungenV2ControllerExportExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange()` */
  static readonly ReportsAbsencesV2ControllerGetAbsencesGroupedForDaterangePath = '/v2/reports/absences/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:absences
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      userId?: number;

    /**
     * Filter by timerecordtype IDs
     */
      timerecordtypeIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsencesReportForUserDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbsencesV2ControllerGetAbsencesGroupedForDaterangePath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('userId', params.userId, {});
      rb.query('timerecordtypeIds', params.timerecordtypeIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsencesReportForUserDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:absences
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange(
    params: {
      dateFrom: string;
      dateTo: string;
      userId?: number;

    /**
     * Filter by timerecordtype IDs
     */
      timerecordtypeIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsencesReportForUserDto>> {
    return this.reportsAbsencesV2ControllerGetAbsencesGroupedForDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsencesReportForUserDto>>): Array<WorkAbsencesReportForUserDto> => r.body)
    );
  }

  /** Path part for operation `reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear()` */
  static readonly ReportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYearPath = '/v2/reports/absences/{dateFrom}/{dateTo}/ratio';

  /**
   * Required permissions: reports:absences
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear$Response(
    params: {
      dateFrom: string;
      dateTo: string;

    /**
     * Filter by user IDs
     */
      userIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAbsencesReportForBusinessDivisionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYearPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('userIds', params.userIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAbsencesReportForBusinessDivisionDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:absences
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear(
    params: {
      dateFrom: string;
      dateTo: string;

    /**
     * Filter by user IDs
     */
      userIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkAbsencesReportForBusinessDivisionDto>> {
    return this.reportsAbsencesV2ControllerGetAbsencesRatioForUsersAndYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAbsencesReportForBusinessDivisionDto>>): Array<WorkAbsencesReportForBusinessDivisionDto> => r.body)
    );
  }

  /** Path part for operation `reportsAusstehendeAufgabenV2ControllerFindAllPaginated()` */
  static readonly ReportsAusstehendeAufgabenV2ControllerFindAllPaginatedPath = '/v2/reports/ausstehende-aufgaben';

  /**
   * Required permissions: reports:ausstehende-aufgaben
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsAusstehendeAufgabenV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAusstehendeAufgabenV2ControllerFindAllPaginated$Response(
    params?: {
      tobNotDoneYet?: boolean;
      tagApproved?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by task.end query param.
     *           <p>
     *              <b>Format: </b> filter.task.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.end=$not:$like:John Doe&filter.task.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.task.end'?: Array<string>;

    /**
     * Filter by task.mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.task.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.mandatory=$not:$like:John Doe&filter.task.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.task.mandatory'?: Array<string>;

    /**
     * Filter by task.standardtaskId query param.
     *           <p>
     *              <b>Format: </b> filter.task.standardtaskId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.standardtaskId=$not:$like:John Doe&filter.task.standardtaskId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.task.standardtaskId'?: Array<string>;

    /**
     * Filter by project.sale query param.
     *           <p>
     *              <b>Format: </b> filter.project.sale={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.sale=$not:$like:John Doe&filter.project.sale=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.sale'?: Array<string>;

    /**
     * Filter by project.build query param.
     *           <p>
     *              <b>Format: </b> filter.project.build={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.build=$not:$like:John Doe&filter.project.build=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.build'?: Array<string>;

    /**
     * Filter by project.implementing query param.
     *           <p>
     *              <b>Format: </b> filter.project.implementing={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.implementing=$not:$like:John Doe&filter.project.implementing=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.implementing'?: Array<string>;

    /**
     * Filter by project.buildingpermit query param.
     *           <p>
     *              <b>Format: </b> filter.project.buildingpermit={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.buildingpermit=$not:$like:John Doe&filter.project.buildingpermit=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.buildingpermit'?: Array<string>;

    /**
     * Filter by project.container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.project.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.container.containertypeId=$not:$like:John Doe&filter.project.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.container.containertypeId'?: Array<string>;

    /**
     * Filter by project.container.contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.project.container.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.container.contact.businessunitId=$not:$like:John Doe&filter.project.container.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.container.contact.businessunitId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>project.sale</li>
     * <li>project.installationStart</li>
     * <li>project.build</li>
     * <li>project.implementing</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'project.sale:ASC' | 'project.sale:DESC' | 'project.installationStart:ASC' | 'project.installationStart:DESC' | 'project.build:ASC' | 'project.build:DESC' | 'project.implementing:ASC' | 'project.implementing:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,standardtask.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>standardtask.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'task.end'?: (string | Array<string>);
'task.mandatory'?: (string | Array<string>);
'task.standardtaskId'?: (string | Array<string>);
'project.sale'?: (string | Array<string>);
'project.build'?: (string | Array<string>);
'project.implementing'?: (string | Array<string>);
'project.buildingpermit'?: (string | Array<string>);
'project.container.containertypeId'?: (string | Array<string>);
'project.container.contact.businessunitId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsAusstehendeAufgabenV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('tobNotDoneYet', params.tobNotDoneYet, {});
      rb.query('tagApproved', params.tagApproved, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.task.end', params['filter.task.end'], {});
      rb.query('filter.task.mandatory', params['filter.task.mandatory'], {});
      rb.query('filter.task.standardtaskId', params['filter.task.standardtaskId'], {});
      rb.query('filter.project.sale', params['filter.project.sale'], {});
      rb.query('filter.project.build', params['filter.project.build'], {});
      rb.query('filter.project.implementing', params['filter.project.implementing'], {});
      rb.query('filter.project.buildingpermit', params['filter.project.buildingpermit'], {});
      rb.query('filter.project.container.containertypeId', params['filter.project.container.containertypeId'], {});
      rb.query('filter.project.container.contact.businessunitId', params['filter.project.container.contact.businessunitId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTask>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'task.end'?: (string | Array<string>);
        'task.mandatory'?: (string | Array<string>);
        'task.standardtaskId'?: (string | Array<string>);
        'project.sale'?: (string | Array<string>);
        'project.build'?: (string | Array<string>);
        'project.implementing'?: (string | Array<string>);
        'project.buildingpermit'?: (string | Array<string>);
        'project.container.containertypeId'?: (string | Array<string>);
        'project.container.contact.businessunitId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: reports:ausstehende-aufgaben
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsAusstehendeAufgabenV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsAusstehendeAufgabenV2ControllerFindAllPaginated(
    params?: {
      tobNotDoneYet?: boolean;
      tagApproved?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by task.end query param.
     *           <p>
     *              <b>Format: </b> filter.task.end={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.end=$not:$like:John Doe&filter.task.end=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.task.end'?: Array<string>;

    /**
     * Filter by task.mandatory query param.
     *           <p>
     *              <b>Format: </b> filter.task.mandatory={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.mandatory=$not:$like:John Doe&filter.task.mandatory=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.task.mandatory'?: Array<string>;

    /**
     * Filter by task.standardtaskId query param.
     *           <p>
     *              <b>Format: </b> filter.task.standardtaskId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.task.standardtaskId=$not:$like:John Doe&filter.task.standardtaskId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.task.standardtaskId'?: Array<string>;

    /**
     * Filter by project.sale query param.
     *           <p>
     *              <b>Format: </b> filter.project.sale={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.sale=$not:$like:John Doe&filter.project.sale=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.sale'?: Array<string>;

    /**
     * Filter by project.build query param.
     *           <p>
     *              <b>Format: </b> filter.project.build={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.build=$not:$like:John Doe&filter.project.build=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.build'?: Array<string>;

    /**
     * Filter by project.implementing query param.
     *           <p>
     *              <b>Format: </b> filter.project.implementing={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.implementing=$not:$like:John Doe&filter.project.implementing=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.project.implementing'?: Array<string>;

    /**
     * Filter by project.buildingpermit query param.
     *           <p>
     *              <b>Format: </b> filter.project.buildingpermit={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.buildingpermit=$not:$like:John Doe&filter.project.buildingpermit=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.buildingpermit'?: Array<string>;

    /**
     * Filter by project.container.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.project.container.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.container.containertypeId=$not:$like:John Doe&filter.project.container.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.container.containertypeId'?: Array<string>;

    /**
     * Filter by project.container.contact.businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.project.container.contact.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.project.container.contact.businessunitId=$not:$like:John Doe&filter.project.container.contact.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.project.container.contact.businessunitId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>project.sale</li>
     * <li>project.installationStart</li>
     * <li>project.build</li>
     * <li>project.implementing</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'project.sale:ASC' | 'project.sale:DESC' | 'project.installationStart:ASC' | 'project.installationStart:DESC' | 'project.build:ASC' | 'project.build:DESC' | 'project.implementing:ASC' | 'project.implementing:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,standardtask.name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>standardtask.name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'task.end'?: (string | Array<string>);
'task.mandatory'?: (string | Array<string>);
'task.standardtaskId'?: (string | Array<string>);
'project.sale'?: (string | Array<string>);
'project.build'?: (string | Array<string>);
'project.implementing'?: (string | Array<string>);
'project.buildingpermit'?: (string | Array<string>);
'project.container.containertypeId'?: (string | Array<string>);
'project.container.contact.businessunitId'?: (string | Array<string>);
};
};
}> {
    return this.reportsAusstehendeAufgabenV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'task.end'?: (string | Array<string>);
'task.mandatory'?: (string | Array<string>);
'task.standardtaskId'?: (string | Array<string>);
'project.sale'?: (string | Array<string>);
'project.build'?: (string | Array<string>);
'project.implementing'?: (string | Array<string>);
'project.buildingpermit'?: (string | Array<string>);
'project.container.containertypeId'?: (string | Array<string>);
'project.container.contact.businessunitId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTask>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'task.end'?: (string | Array<string>);
'task.mandatory'?: (string | Array<string>);
'task.standardtaskId'?: (string | Array<string>);
'project.sale'?: (string | Array<string>);
'project.build'?: (string | Array<string>);
'project.implementing'?: (string | Array<string>);
'project.buildingpermit'?: (string | Array<string>);
'project.container.containertypeId'?: (string | Array<string>);
'project.container.contact.businessunitId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `reportsBuildsV2ControllerFindNotPlannedByContainerId()` */
  static readonly ReportsBuildsV2ControllerFindNotPlannedByContainerIdPath = '/v2/reports/builds/notPlanned/{containertypeId}';

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-bau
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsBuildsV2ControllerFindNotPlannedByContainerId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsBuildsV2ControllerFindNotPlannedByContainerId$Response(
    params: {
      containertypeId: number;
      withDetails?: boolean;
      userIds?: Array<number>;
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkRevenueByYearAndMonthDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsBuildsV2ControllerFindNotPlannedByContainerIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.query('withDetails', params.withDetails, {});
      rb.query('userIds', params.userIds, {});
      rb.query('includeMontageaufwand', params.includeMontageaufwand, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkRevenueByYearAndMonthDto>;
      })
    );
  }

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-bau
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsBuildsV2ControllerFindNotPlannedByContainerId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsBuildsV2ControllerFindNotPlannedByContainerId(
    params: {
      containertypeId: number;
      withDetails?: boolean;
      userIds?: Array<number>;
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkRevenueByYearAndMonthDto> {
    return this.reportsBuildsV2ControllerFindNotPlannedByContainerId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkRevenueByYearAndMonthDto>): WorkRevenueByYearAndMonthDto => r.body)
    );
  }

  /** Path part for operation `reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth()` */
  static readonly ReportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonthPath = '/v2/reports/builds/{containertypeId}/{year}/{month}';

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-bau
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth$Response(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;

    /**
     * Überschreibt die Containertype-Config, ob der Montageaufwand aus den erfassten Stunden im Deckungsbeitrag zählt.
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkBuildsByContainerIdYearAndMonthDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonthPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
      rb.query('withDetails', params.withDetails, {});
      rb.query('userIds', params.userIds, {});
      rb.query('includeMontageaufwand', params.includeMontageaufwand, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkBuildsByContainerIdYearAndMonthDto>;
      })
    );
  }

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-bau
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;

    /**
     * Überschreibt die Containertype-Config, ob der Montageaufwand aus den erfassten Stunden im Deckungsbeitrag zählt.
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkBuildsByContainerIdYearAndMonthDto> {
    return this.reportsBuildsV2ControllerFindBuildsByContainerIdYearAndMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkBuildsByContainerIdYearAndMonthDto>): WorkBuildsByContainerIdYearAndMonthDto => r.body)
    );
  }

  /** Path part for operation `reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth()` */
  static readonly ReportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonthPath = '/v2/reports/revenue-forecast/{containertypeId}/{year}/{month}';

  /**
   * Required permissions: reports:prognostizierter-umsatz
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth$Response(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkRevenueForecastByContainerIdYearAndMonthDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonthPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
      rb.query('withDetails', params.withDetails, {});
      rb.query('userIds', params.userIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkRevenueForecastByContainerIdYearAndMonthDto>;
      })
    );
  }

  /**
   * Required permissions: reports:prognostizierter-umsatz
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<WorkRevenueForecastByContainerIdYearAndMonthDto> {
    return this.reportsRevenueForecastV2ControllerFindRevenueForecastByContainerIdYearAndMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkRevenueForecastByContainerIdYearAndMonthDto>): WorkRevenueForecastByContainerIdYearAndMonthDto => r.body)
    );
  }

  /** Path part for operation `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange()` */
  static readonly ReportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangePath = '/v2/reports/debitorenabgleich/debtors-paid/{fromDate}/{toDate}';

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDebtor>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDebtor>>;
      })
    );
  }

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkDebtor>> {
    return this.reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDebtor>>): Array<WorkDebtor> => r.body)
    );
  }

  /** Path part for operation `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv()` */
  static readonly ReportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsvPath = '/v2/reports/debitorenabgleich/debtors-paid/{fromDate}/{toDate}/csv';

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsvPath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reportsDebitorenabgleichV2ControllerFindDebtorsPaidByDaterangeCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport()` */
  static readonly ReportsDebitorenabgleichV2ControllerUploadDebtorsBankImportPath = '/v2/reports/debitorenabgleich/debtors-bank-import';

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport$Response(
    params: {
      body: WorkUploadBankFileDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTransformedBankFileDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsDebitorenabgleichV2ControllerUploadDebtorsBankImportPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTransformedBankFileDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:debitorenabstimmung
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport(
    params: {
      body: WorkUploadBankFileDto
    },
    context?: HttpContext
  ): Observable<Array<WorkTransformedBankFileDto>> {
    return this.reportsDebitorenabgleichV2ControllerUploadDebtorsBankImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTransformedBankFileDto>>): Array<WorkTransformedBankFileDto> => r.body)
    );
  }

  /** Path part for operation `reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear()` */
  static readonly ReportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYearPath = '/v2/reports/jahresendverarbeitung/krankheitunfalltage/{year}';

  /**
   * Required permissions: reports:jahresendverabeitung
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear$Response(
    params: {
      year: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYearPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:jahresendverabeitung
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear(
    params: {
      year: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkKrankheitUnfallTageDto>> {
    return this.reportsJahresendverarbeitungV2ControllerFindKrankheitUnfallTageForYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>): Array<WorkKrankheitUnfallTageDto> => r.body)
    );
  }

  /** Path part for operation `reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear()` */
  static readonly ReportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYearPath = '/v2/reports/jahresendverarbeitung/changed-useremployments/{year}';

  /**
   * Required permissions: reports:jahresendverabeitung
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear$Response(
    params: {
      useremploymentType: WorkUseremploymentTypeEnum;
      year: number;
      entriesOnly?: boolean;
      exitsOnly?: boolean;
      holidaysChangeOnly?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUseremployment>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYearPath, 'get');
    if (params) {
      rb.query('useremploymentType', params.useremploymentType, {});
      rb.path('year', params.year, {});
      rb.query('entriesOnly', params.entriesOnly, {});
      rb.query('exitsOnly', params.exitsOnly, {});
      rb.query('holidaysChangeOnly', params.holidaysChangeOnly, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUseremployment>>;
      })
    );
  }

  /**
   * Required permissions: reports:jahresendverabeitung
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear(
    params: {
      useremploymentType: WorkUseremploymentTypeEnum;
      year: number;
      entriesOnly?: boolean;
      exitsOnly?: boolean;
      holidaysChangeOnly?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkUseremployment>> {
    return this.reportsJahresendverarbeitungV2ControllerFindChangedUseremploymentsForYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUseremployment>>): Array<WorkUseremployment> => r.body)
    );
  }

  /** Path part for operation `reportsLeadsV2ControllerGetConversions()` */
  static readonly ReportsLeadsV2ControllerGetConversionsPath = '/v2/reports/leads/conversions/forDaterange/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLeadsV2ControllerGetConversions()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetConversions$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
      categoryIds: Array<string>;
      userIds: Array<string>;
      sortBy: string;
      hasObjektbesichtigung: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLeadConversionDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLeadsV2ControllerGetConversionsPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('categoryIds', params.categoryIds, {});
      rb.query('userIds', params.userIds, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('hasObjektbesichtigung', params.hasObjektbesichtigung, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLeadConversionDto>;
      })
    );
  }

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLeadsV2ControllerGetConversions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetConversions(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
      categoryIds: Array<string>;
      userIds: Array<string>;
      sortBy: string;
      hasObjektbesichtigung: boolean;
    },
    context?: HttpContext
  ): Observable<WorkLeadConversionDto> {
    return this.reportsLeadsV2ControllerGetConversions$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLeadConversionDto>): WorkLeadConversionDto => r.body)
    );
  }

  /** Path part for operation `reportsLeadsV2ControllerGetLeadsCharts()` */
  static readonly ReportsLeadsV2ControllerGetLeadsChartsPath = '/v2/reports/leads/leadsCharts/forDaterange/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLeadsV2ControllerGetLeadsCharts()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetLeadsCharts$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
      categoryIds: Array<string>;
      userIds: Array<string>;
      sortBy: string;
      hasObjektbesichtigung: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLeadsChartsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLeadsV2ControllerGetLeadsChartsPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('categoryIds', params.categoryIds, {});
      rb.query('userIds', params.userIds, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('hasObjektbesichtigung', params.hasObjektbesichtigung, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLeadsChartsDto>;
      })
    );
  }

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLeadsV2ControllerGetLeadsCharts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetLeadsCharts(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
      categoryIds: Array<string>;
      userIds: Array<string>;
      sortBy: string;
      hasObjektbesichtigung: boolean;
    },
    context?: HttpContext
  ): Observable<WorkLeadsChartsDto> {
    return this.reportsLeadsV2ControllerGetLeadsCharts$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLeadsChartsDto>): WorkLeadsChartsDto => r.body)
    );
  }

  /** Path part for operation `reportsLeadsV2ControllerGetReservationsCharts()` */
  static readonly ReportsLeadsV2ControllerGetReservationsChartsPath = '/v2/reports/leads/reservationsCharts/forDaterange/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLeadsV2ControllerGetReservationsCharts()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetReservationsCharts$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationsChartsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLeadsV2ControllerGetReservationsChartsPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('businessunitIds', params.businessunitIds, {});
      rb.query('containertypeIds', params.containertypeIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationsChartsDto>;
      })
    );
  }

  /**
   * Required permissions: reports:leadconversion
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLeadsV2ControllerGetReservationsCharts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLeadsV2ControllerGetReservationsCharts(
    params: {
      dateFrom: string;
      dateTo: string;
      businessunitIds: Array<string>;
      containertypeIds: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkReservationsChartsDto> {
    return this.reportsLeadsV2ControllerGetReservationsCharts$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationsChartsDto>): WorkReservationsChartsDto => r.body)
    );
  }

  /** Path part for operation `reportsLohnlaufV2ControllerFindSpesentageForDaterange()` */
  static readonly ReportsLohnlaufV2ControllerFindSpesentageForDaterangePath = '/v2/reports/lohnlauf/spesentage/{fromDate}/{toDate}';

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLohnlaufV2ControllerFindSpesentageForDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindSpesentageForDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSpesentageDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLohnlaufV2ControllerFindSpesentageForDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSpesentageDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLohnlaufV2ControllerFindSpesentageForDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindSpesentageForDaterange(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkSpesentageDto>> {
    return this.reportsLohnlaufV2ControllerFindSpesentageForDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSpesentageDto>>): Array<WorkSpesentageDto> => r.body)
    );
  }

  /** Path part for operation `reportsLohnlaufV2ControllerFindWegspesenForDaterange()` */
  static readonly ReportsLohnlaufV2ControllerFindWegspesenForDaterangePath = '/v2/reports/lohnlauf/wegspesen/{fromDate}/{toDate}';

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLohnlaufV2ControllerFindWegspesenForDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindWegspesenForDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkWegspesenDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLohnlaufV2ControllerFindWegspesenForDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkWegspesenDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLohnlaufV2ControllerFindWegspesenForDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindWegspesenForDaterange(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkWegspesenDto>> {
    return this.reportsLohnlaufV2ControllerFindWegspesenForDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkWegspesenDto>>): Array<WorkWegspesenDto> => r.body)
    );
  }

  /** Path part for operation `reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange()` */
  static readonly ReportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterangePath = '/v2/reports/lohnlauf/krankheitunfalltage/{fromDate}/{toDate}';

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkKrankheitUnfallTageDto>> {
    return this.reportsLohnlaufV2ControllerFindKrankheitUnfallTageForDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkKrankheitUnfallTageDto>>): Array<WorkKrankheitUnfallTageDto> => r.body)
    );
  }

  /** Path part for operation `reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth()` */
  static readonly ReportsLohnlaufV2ControllerFindChangedUseremploymentsForMonthPath = '/v2/reports/lohnlauf/changed-useremployments/{month}';

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth$Response(
    params: {
      useremploymentType: WorkUseremploymentTypeEnum;
      month: number;
      mutationType: WorkUseremploymentMutationTypesEnum;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUseremploymentWithChangesDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLohnlaufV2ControllerFindChangedUseremploymentsForMonthPath, 'get');
    if (params) {
      rb.query('useremploymentType', params.useremploymentType, {});
      rb.path('month', params.month, {});
      rb.query('mutationType', params.mutationType, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUseremploymentWithChangesDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:lohnlauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth(
    params: {
      useremploymentType: WorkUseremploymentTypeEnum;
      month: number;
      mutationType: WorkUseremploymentMutationTypesEnum;
    },
    context?: HttpContext
  ): Observable<Array<WorkUseremploymentWithChangesDto>> {
    return this.reportsLohnlaufV2ControllerFindChangedUseremploymentsForMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUseremploymentWithChangesDto>>): Array<WorkUseremploymentWithChangesDto> => r.body)
    );
  }

  /** Path part for operation `reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser()` */
  static readonly ReportsLohnlisteV2ControllerGetLohnlisteForYearAndUserPath = '/v2/reports/lohnliste/lohnliste/{year}/{userId}';

  /**
   * Required permissions: reports:lohnliste
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser$Response(
    params: {
      year: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLohnlisteEntryDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsLohnlisteV2ControllerGetLohnlisteForYearAndUserPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLohnlisteEntryDto>;
      })
    );
  }

  /**
   * Required permissions: reports:lohnliste
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser(
    params: {
      year: number;
      userId: number;
    },
    context?: HttpContext
  ): Observable<WorkLohnlisteEntryDto> {
    return this.reportsLohnlisteV2ControllerGetLohnlisteForYearAndUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLohnlisteEntryDto>): WorkLohnlisteEntryDto => r.body)
    );
  }

  /** Path part for operation `reportsNochNichtFakturierteLeistungenV2ControllerGetProjects()` */
  static readonly ReportsNochNichtFakturierteLeistungenV2ControllerGetProjectsPath = '/v2/reports/noch-nicht-fakturierte-leistungen/projects';

  /**
   * Required permissions: reports:noch-nicht-fakturierte-leistungen
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsNochNichtFakturierteLeistungenV2ControllerGetProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsNochNichtFakturierteLeistungenV2ControllerGetProjects$Response(
    params?: {
      containertypeIds?: Array<number>;

    /**
     * Wenn true: nur Projekte zeigen, bei denen die Abschlussrechnungs-Aufgabe ein Fälligkeitsdatum gesetzt hat.
     */
      abschlussrechnungDueIsSet?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkNochNichtFakturierteLeistungenProjectDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsNochNichtFakturierteLeistungenV2ControllerGetProjectsPath, 'get');
    if (params) {
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('abschlussrechnungDueIsSet', params.abschlussrechnungDueIsSet, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkNochNichtFakturierteLeistungenProjectDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:noch-nicht-fakturierte-leistungen
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsNochNichtFakturierteLeistungenV2ControllerGetProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsNochNichtFakturierteLeistungenV2ControllerGetProjects(
    params?: {
      containertypeIds?: Array<number>;

    /**
     * Wenn true: nur Projekte zeigen, bei denen die Abschlussrechnungs-Aufgabe ein Fälligkeitsdatum gesetzt hat.
     */
      abschlussrechnungDueIsSet?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkNochNichtFakturierteLeistungenProjectDto>> {
    return this.reportsNochNichtFakturierteLeistungenV2ControllerGetProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkNochNichtFakturierteLeistungenProjectDto>>): Array<WorkNochNichtFakturierteLeistungenProjectDto> => r.body)
    );
  }

  /** Path part for operation `reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions()` */
  static readonly ReportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptionsPath = '/v2/reports/performance-kundenberater/kundenberater-dropdown-options';

  /**
   * Required permissions: reports:performance-kundenberater
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:performance-kundenberater
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.reportsPerformanceKundenberaterV2ControllerGetKundenberaterDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `reportsPerformanceKundenberaterV2ControllerFindAll()` */
  static readonly ReportsPerformanceKundenberaterV2ControllerFindAllPath = '/v2/reports/performance-kundenberater/forDaterange/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:performance-kundenberater
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsPerformanceKundenberaterV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceKundenberaterV2ControllerFindAll$Response(
    params: {
      dateFrom: string;
      dateTo: string;
      userIds: Array<string>;
      containertypeIds: Array<string>;
      sortBy: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkPerformanceKundenberaterDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsPerformanceKundenberaterV2ControllerFindAllPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
      rb.query('userIds', params.userIds, {});
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkPerformanceKundenberaterDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:performance-kundenberater
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsPerformanceKundenberaterV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceKundenberaterV2ControllerFindAll(
    params: {
      dateFrom: string;
      dateTo: string;
      userIds: Array<string>;
      containertypeIds: Array<string>;
      sortBy: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkPerformanceKundenberaterDto>> {
    return this.reportsPerformanceKundenberaterV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkPerformanceKundenberaterDto>>): Array<WorkPerformanceKundenberaterDto> => r.body)
    );
  }

  /** Path part for operation `reportsPerformanceMontageV2ControllerGetPerformance()` */
  static readonly ReportsPerformanceMontageV2ControllerGetPerformancePath = '/v2/reports/performance-montage';

  /**
   * Required permissions: reports:performance-montage
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsPerformanceMontageV2ControllerGetPerformance()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceMontageV2ControllerGetPerformance$Response(
    params: {
      fromDate: string;
      toDate: string;
      containertypeIds?: Array<number>;
      teamIds?: Array<number>;
      userIds?: Array<number>;

    /**
     * Liefert zu jeder Zeile die beitragenden Projekte mit Stundenanteil (für den Drill-Down).
     */
      withProjectDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPerformanceMontageDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsPerformanceMontageV2ControllerGetPerformancePath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('teamIds', params.teamIds, {});
      rb.query('userIds', params.userIds, {});
      rb.query('withProjectDetails', params.withProjectDetails, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPerformanceMontageDto>;
      })
    );
  }

  /**
   * Required permissions: reports:performance-montage
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsPerformanceMontageV2ControllerGetPerformance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsPerformanceMontageV2ControllerGetPerformance(
    params: {
      fromDate: string;
      toDate: string;
      containertypeIds?: Array<number>;
      teamIds?: Array<number>;
      userIds?: Array<number>;

    /**
     * Liefert zu jeder Zeile die beitragenden Projekte mit Stundenanteil (für den Drill-Down).
     */
      withProjectDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkPerformanceMontageDto> {
    return this.reportsPerformanceMontageV2ControllerGetPerformance$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPerformanceMontageDto>): WorkPerformanceMontageDto => r.body)
    );
  }

  /** Path part for operation `reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth()` */
  static readonly ReportsSalesV2ControllerFindSalesByContainerIdYearAndMonthPath = '/v2/reports/sales/byContainerYearAndMonth/{containertypeId}/{year}/{month}';

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-verkauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth$Response(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;

    /**
     * Überschreibt die Containertype-Config, ob der Montageaufwand aus den erfassten Stunden im Deckungsbeitrag zählt.
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkRevenueByYearAndMonthDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsSalesV2ControllerFindSalesByContainerIdYearAndMonthPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.path('year', params.year, {});
      rb.path('month', params.month, {});
      rb.query('withDetails', params.withDetails, {});
      rb.query('userIds', params.userIds, {});
      rb.query('includeMontageaufwand', params.includeMontageaufwand, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkRevenueByYearAndMonthDto>;
      })
    );
  }

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-verkauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth(
    params: {
      containertypeId: number;
      year: number;
      month: number;
      withDetails?: boolean;
      userIds?: Array<number>;

    /**
     * Überschreibt die Containertype-Config, ob der Montageaufwand aus den erfassten Stunden im Deckungsbeitrag zählt.
     */
      includeMontageaufwand?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkRevenueByYearAndMonthDto> {
    return this.reportsSalesV2ControllerFindSalesByContainerIdYearAndMonth$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkRevenueByYearAndMonthDto>): WorkRevenueByYearAndMonthDto => r.body)
    );
  }

  /** Path part for operation `reportsSalesV2ControllerFindSalesByContainerTypeId()` */
  static readonly ReportsSalesV2ControllerFindSalesByContainerTypeIdPath = '/v2/reports/sales/byContainerTypeId/{containertypeId}';

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-verkauf
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsSalesV2ControllerFindSalesByContainerTypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSalesV2ControllerFindSalesByContainerTypeId$Response(
    params: {
      containertypeId: number;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSalesByContainertypeDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsSalesV2ControllerFindSalesByContainerTypeIdPath, 'get');
    if (params) {
      rb.path('containertypeId', params.containertypeId, {});
      rb.query('withDetails', params.withDetails, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSalesByContainertypeDto>;
      })
    );
  }

  /**
   * Required permissions: reports:umsatz-deckungsbeitrag-verkauf
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsSalesV2ControllerFindSalesByContainerTypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSalesV2ControllerFindSalesByContainerTypeId(
    params: {
      containertypeId: number;
      withDetails?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkSalesByContainertypeDto> {
    return this.reportsSalesV2ControllerFindSalesByContainerTypeId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSalesByContainertypeDto>): WorkSalesByContainertypeDto => r.body)
    );
  }

  /** Path part for operation `reportsSensDeklarationV2ControllerFindForDaterange()` */
  static readonly ReportsSensDeklarationV2ControllerFindForDaterangePath = '/v2/reports/sens-deklaration/{fromDate}/{toDate}';

  /**
   * Required permissions: reports:sens-deklaration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsSensDeklarationV2ControllerFindForDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSensDeklarationV2ControllerFindForDaterange$Response(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSensDeklarationItemDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsSensDeklarationV2ControllerFindForDaterangePath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSensDeklarationItemDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:sens-deklaration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsSensDeklarationV2ControllerFindForDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsSensDeklarationV2ControllerFindForDaterange(
    params: {
      fromDate: string;
      toDate: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkSensDeklarationItemDto>> {
    return this.reportsSensDeklarationV2ControllerFindForDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSensDeklarationItemDto>>): Array<WorkSensDeklarationItemDto> => r.body)
    );
  }

  /** Path part for operation `reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa()` */
  static readonly ReportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKaPath = '/v2/reports/statistics-and-facts/axova/ka/{year}';

  /**
   * Required permissions: reports:interesting-stats-for-year
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa$Response(
    params: {
      year: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkStatisticsAndFactsForAxovaKaDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKaPath, 'get');
    if (params) {
      rb.path('year', params.year, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkStatisticsAndFactsForAxovaKaDto>;
      })
    );
  }

  /**
   * Required permissions: reports:interesting-stats-for-year
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa(
    params: {
      year: number;
    },
    context?: HttpContext
  ): Observable<WorkStatisticsAndFactsForAxovaKaDto> {
    return this.reportsStatisticsAndFactsV2ControllerGetStatisticsAndFactorsForAxovaKa$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkStatisticsAndFactsForAxovaKaDto>): WorkStatisticsAndFactsForAxovaKaDto => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsersPath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/usersEmployedInDaterange/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers$Response(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUserV2>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsersPath, 'get');
    if (params) {
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUserV2>>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkUserV2>> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUserV2>>): Array<WorkUserV2> => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDatePath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/worktimeByUserIdAndDate/{userId}/{date}';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate$Response(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecorddetailsByDateDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDatePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('date', params.date, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecorddetailsByDateDto>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate(
    params: {
      userId: number;
      date: string;
    },
    context?: HttpContext
  ): Observable<WorkTimerecorddetailsByDateDto> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecorddetailsByDateDto>): WorkTimerecorddetailsByDateDto => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterangePath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/worktimeByUserIdAndDaterange/{userId}/{dateFrom}/{dateTo}';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange$Response(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterangePath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('dateFrom', params.dateFrom, {});
      rb.path('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange(
    params: {
      userId: number;
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecorddetailsByDateDto>> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindWorktimeByUserIdAndDaterange$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecorddetailsByDateDto>>): Array<WorkTimerecorddetailsByDateDto> => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgentPath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/datesWithTimerecorddetailsNotSentToAgent';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecorddetailsGroupedByUserDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgentPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecorddetailsGroupedByUserDto>>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecorddetailsGroupedByUserDto>> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerFindDatesWithTimerecorddetailsNotSentToAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecorddetailsGroupedByUserDto>>): Array<WorkTimerecorddetailsGroupedByUserDto> => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgentPath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/datesWithTimerecorddetailsNotSentToAgent';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgentPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAllDatesWithTimerecorddetailsNotSentToAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgentsPath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/sendEmailToAgents';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents$Response(
    params: {
      body: WorkSendEmailToAgentsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgentsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents(
    params: {
      body: WorkSendEmailToAgentsDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerSendEmailToAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents()` */
  static readonly ReportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgentsPath = '/v2/reports/stundenmeldung-temporaere-mitarbeiter/markAsSentToAgents';

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents$Response(
    params: {
      body: WorkSendEmailToAgentsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgentsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: reports:stundenmeldung-temporaere-mitarbeiter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents(
    params: {
      body: WorkSendEmailToAgentsDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reportsStundenmeldungTemporaereMitarbeiterV2ControllerMarkAsSentToAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reportsV2ControllerFindCalcutationitemsByStocklocationId()` */
  static readonly ReportsV2ControllerFindCalcutationitemsByStocklocationIdPath = '/v2/reports/calculationitems/byStocklocationId';

  /**
   * Required permissions: reports:lagerbestand
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsV2ControllerFindCalcutationitemsByStocklocationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsV2ControllerFindCalcutationitemsByStocklocationId$Response(
    params?: {
      stocklocationIds?: Array<number>;
      deliveredAt?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsV2ControllerFindCalcutationitemsByStocklocationIdPath, 'get');
    if (params) {
      rb.query('stocklocationIds', params.stocklocationIds, {});
      rb.query('deliveredAt', params.deliveredAt, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: reports:lagerbestand
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsV2ControllerFindCalcutationitemsByStocklocationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsV2ControllerFindCalcutationitemsByStocklocationId(
    params?: {
      stocklocationIds?: Array<number>;
      deliveredAt?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.reportsV2ControllerFindCalcutationitemsByStocklocationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId()` */
  static readonly ReportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserIdPath = '/v2/reports/monthly-timerecord-balances-for-daterange/{fromDate}/{toDate}/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId$Response(
    params: {
      fromDate: string;
      toDate: string;
      userId: number;
      subtotalDate?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecordBalancesByYearMonthAndUserIdDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReportsV2Service.ReportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserIdPath, 'get');
    if (params) {
      rb.path('fromDate', params.fromDate, {});
      rb.path('toDate', params.toDate, {});
      rb.path('userId', params.userId, {});
      rb.query('subtotalDate', params.subtotalDate, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecordBalancesByYearMonthAndUserIdDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId(
    params: {
      fromDate: string;
      toDate: string;
      userId: number;
      subtotalDate?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecordBalancesByYearMonthAndUserIdDto>> {
    return this.reportsV2ControllerFindMonthlyTimerecordBalancesByDaterangeAndUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecordBalancesByYearMonthAndUserIdDto>>): Array<WorkTimerecordBalancesByYearMonthAndUserIdDto> => r.body)
    );
  }

}
